/**
 * Reads the parameters Backoffice forwarded as `x-query-*` headers.
 *
 * Deliberately unfiltered: BO has already intersected the incoming query with
 * its own *Flexible Tracking-Parameter* list before setting these, so filtering
 * again against NCF's settings would drop parameters a customer configured on
 * the BO side and not (yet) on ours.
 */
export function extractQueryHeaders(headers: Record<string, string>): QueryHeader[] {
  const queryHeaders: QueryHeader[] = []

  for (const [key, value] of Object.entries(headers)) {
    if (key.startsWith("x-query-")) {
      const paramName = key.slice(8) // Remove 'x-query-' part
      const queryHeader: QueryHeader = {
        key: paramName,
        value,
      }

      queryHeaders.push(queryHeader)
    }
  }

  return queryHeaders
}

/**
 * The tracking parameters in play for this visit — forwarded onto outbound links
 * by v-append-parameters and mapped into `other.customFields` on the application
 * payload (composables/useApplicationFormData.ts).
 *
 * A plain accessor: plugins/tracking-bag.server.ts fills it once per request
 * (JET-2720) and the client hydrates it from the payload.
 */
export function useQueryHeaders() {
  return useState<QueryHeader[]>("queryHeaders", () => [])
}
